import { render } from "./YongjiuQuanyiList.vue?vue&type=template&id=222e88f0&scoped=true"
import script from "./YongjiuQuanyiList.vue?vue&type=script&lang=js"
export * from "./YongjiuQuanyiList.vue?vue&type=script&lang=js"

import "./YongjiuQuanyiList.vue?vue&type=style&index=0&id=222e88f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222e88f0"]])

export default __exports__